<template>
  <lu-vbox id='app' lu-flex class='app-main'>

    <lu-item><PageHeader :title=' $t("Account Validation")'/></lu-item>

    <!-- <lu-item class='login-logo'></lu-item> -->
    <lu-item class='logo'  :style='loginLogoStyle' />

    <lu-vbox lu-hcenter>
      <lu-item v-if='message' style='font-size: 1.5rem; padding: 10px;color: #13ce66' class='mar-t-10'>
        {{ message }}
      </lu-item>

      <lu-item v-if='inputCodeMode' style='font-size: 1.5rem; padding: 15px;' class='mar-t-10'>
        {{ this.$t('Enter the email address used for signup and the validation code received by email') }}
      </lu-item>

    </lu-vbox>
    <lu-vbox v-if='inputCodeMode' class='page' lu-hcenter>
      <el-form ref='form' :model='form' label-width="80px" class='lu-flex lu-flex-wrap' :rules='rules'>
          <el-form-item :label='$t("E-mail")' prop='email' :required='true' >
            <el-input v-model='form.email' />
          </el-form-item>
          <el-form-item :label='$t("Code")' prop='codeActivation'  :required='codeRequired'>
            <el-input v-model='form.codeActivation' />
          </el-form-item>
      </el-form>
      <lu-hbox class='mar-t-10 pad-in-20'>
        <lu-item><el-button type="primary" class='button' icon='el-icon-check' @click="validateSignup">{{ $t('Validate') }}</el-button></lu-item>
        <lu-item><el-button vs-if='isRegenCode' type="primary" class='button' icon='el-icon-check' @click="regenerateAccountCode">{{ $t('Regenerate Code') }}</el-button></lu-item>
      </lu-hbox>
    </lu-vbox>
  </lu-vbox>
</template>

<script>
import { LuVbox, LuHbox, LuItem } from 'lusis-ui'
import PageHeader from '@/components/PageHeader'
import messageHandler from '@/mixins/message'
import variableHandler from '@/mixins/variables'

export default {
  name: 'Signup',
  mixins: [ messageHandler, variableHandler ],
  components: { LuVbox, LuHbox, LuItem, PageHeader },
  methods: {
    regenerateAccountCode: function () {
      let rule = this.rules.codeActivation
      delete this.rules.codeActivation
      this.codeRequired = false
      this.$nextTick().then(() => {
        this.$refs.form.validate((valid) => {
          this.rules.codeActivation = rule
          this.codeRequired = true
          if (valid) {
            //this.connectToServer().then(server => server.regenerateAccountCode(this.form.email).then(rep => {
            this.connectToServer().then(() => this.$tango.regenerateAccountCode(this.form.email).then(rep => {

              if (rep.resultCode === 8) {
                this.isRegenCode = true
                this.message = this.$t('User not found with this e-mail, Please check e-mail')
              }
              else if (rep.resultCode !== 0) {
                this.isSuccess = false
                this.isRegenCode = true
                this.message = this.$t('Regenerate code request failed')
              }
              else {
                this.isSuccess = true
                this.isRegenCode = false
                this.message = this.$t('Regenerate code request has been completed successfully')
              }
            // eslint-disable-next-line no-unused-vars
            })).catch(err => {
              this.message = this.$t('Error: technical ')
            })
          }
        })
      })
   },
   validateSignup: function () {
      if (this.inputCodeMode) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            let cond = {
              userEmail: this.form.email,
              codeActivation: this.form.codeActivation
            }
            this.tangoUpdate(cond)
          }
        })
      }
      else {
        let cond = {
          userEmail: this.$route.params.email,
          destCode: this.$route.params.hash
        }
        this.tangoUpdate(cond)
      }
    },
    tangoUpdate (cond) {
      //this.connectToServer().then(server => server.validateUser(cond)).then(rep => {
      this.connectToServer().then(() => this.$tango.validateUser(cond)).then(rep => {
        if (rep.resultCode === 0) {
          this.isSuccess = true
          this.message = this.$t('User validation has been completed successfully')
          // eslint-disable-next-line no-unused-vars
          this.$router.push('/login').catch(err => {})
        }
        else if (rep.resultCode === 1) {
          this.isRegenCode = true
          this.message = this.$t('Missing fields')
        }
        else if (rep.resultCode === 6) {
          this.isRegenCode = true
          this.message = this.$t('Invalid Code, Plesase re-entre the validation code')
        }
        else if (rep.resultCode === 8) {
          this.isRegenCode = true
          this.message = this.$t('User not found with this e-mail, Please check e-mail')
        }
        else if (rep.resultCode === 13) {
          this.isRegenCode = true
          this.message = this.$t('Wrong user status')
        }
        else if (rep.resultCode === 14) {
          this.message = this.$t('User already actif')
        }
        else {
          this.message = this.$t('Error: User validation has failed')
        }
      // eslint-disable-next-line no-unused-vars
      }).catch(err => {
        this.message = this.$t('Error: technical ')
      })
    }
  },
  created: function () {
    if (!this.inputCodeMode) this.validateSignup()
    // this.message = this.$t('Regenerate code request has been completed successfully')
  },
  computed: {
    theme() {
      return this.$store.state.settings.theme
    },
    inputCodeMode: function () {
      return !(this.$route && this.$route.params && this.$route.params.email && this.$route.params.hash && !this.isRegenCode)
    }
  },
  data: function () {
    return {
      form: {
        email: this.$route.params.email,
        codeActivation: null
      },
      codeRequired: true,
      isSuccess: false,
      isRegenCode: false,
      message: '',
      rules: {
        email: [
          { required: true, message: 'Please input e-mail address', trigger: ['blur', 'change'] },
          { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
        ],
        codeActivation: [
          { required: true, message: this.$t('Please input code'), trigger: ['blur', 'change'] }
        ]
      }
    }
  }
}
</script>

<style scoped>

.logo {
    margin-bottom: 10px;
    background: none no-repeat center;
    background-size: contain;
    height: 100px;
    width:100%;
  }

</style>
